/**
 * UrlConverter
 *
 * A Lit attribute converter that converts string attributes to and
 * from instances of the native URL class.
 *
 * See: https://lit.dev/docs/components/properties/#conversion-converter
 */
export const UrlConverter = {
  fromAttribute: (value, type) => {
    if (type !== URL) {
      throw new Error('UrlConverter() expects type to be "URL"');
    }

    // Include the base URL, otherwise relative URLs will error.
    return new URL(value, location.protocol + location.host);
  },
  toAttribute: (value, type) => {
    if (type !== URL) {
      throw new Error('UrlConverter() expects type to be "URL"');
    }

    if (!(value instanceof URL)) {
      throw new Error(
        'UrlConverter() expects value to be an instance of "URL"'
      );
    }

    return value.href;
  },
};
